import { useIsAuthenticated } from './use-is-authenticated'
import {
  selectAcceptedTermsAt,
  selectIsGroupOwner,
  selectUserGroupId,
  selectUserGroupVersion,
} from '../state/dashboard/dashboard.slice'
import { useAppSelector } from '../state/rootReducer'

export enum APP {
  FAMILY = 'family',
  DASHBOARD = 'dashboard',
}

export const useGetUserApp = (): APP | null => {
  const isAuthenticated = useIsAuthenticated()
  const groupId = useAppSelector(selectUserGroupId)
  const groupVersion = useAppSelector(selectUserGroupVersion)
  const isOwner = useAppSelector(selectIsGroupOwner)
  const acceptedTermsAt = useAppSelector(selectAcceptedTermsAt)

  if (!isAuthenticated) {
    return null
  }

  const isGroup = !!groupId
  const isFamily = isGroup && groupVersion === 2 && (isOwner || acceptedTermsAt)

  return isFamily ? APP.FAMILY : APP.DASHBOARD
}
